export default ({ COLORS }) => ({})
